import { MapPin, Mail, Phone, Award, Factory, Users } from 'lucide-react';
import { useSiteSettings } from '@/hooks/useSiteSettings';

export default function About() {
    const s = useSiteSettings();
    return (
        <div>
            <section className="bg-white border-b border-slate-200">
                <div className="kanbr-container py-10">
                    <div className="eyebrow mb-2">About Kanbr Concepts</div>
                    <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight max-w-3xl">Precision manufacturing meets honest pricing.</h1>
                    <p className="text-slate-600 mt-4 text-sm md:text-base max-w-3xl leading-relaxed">
                        Kanbr Concepts is an NCR-based manufacturer of modular wardrobes and modular kitchens. We serve homeowners directly and partner with independent designers, architects and contractors across India. Our factory-first model removes dealer markups and puts craftsmanship first.
                    </p>
                </div>
            </section>

            <section className="kanbr-container py-10 grid grid-cols-1 md:grid-cols-3 gap-4">
                {[
                    { i: <Factory className="w-5 h-5" />, t: 'Our factory', d: 'Modern CNC-driven workshop in HSIIDC Kundli (NCR) with dedicated cutting, edgebanding and finishing lines.' },
                    { i: <Award className="w-5 h-5" />, t: 'Quality standards', d: 'HDHMR & commercial-ply carcass, brand-name laminates and tested hardware — with a 10-year warranty.' },
                    { i: <Users className="w-5 h-5" />, t: 'Who we serve', d: 'Homeowners, interior designers, architects and contractors — one clean pipeline from drawing to install.' },
                ].map((c, i) => (
                    <div key={i} className="border border-slate-200 bg-white p-5">
                        <div className="w-10 h-10 bg-blue-900 text-white flex items-center justify-center mb-3">{c.i}</div>
                        <h3 className="font-display font-semibold text-slate-900 text-base">{c.t}</h3>
                        <p className="text-xs text-slate-600 mt-2 leading-relaxed">{c.d}</p>
                    </div>
                ))}
            </section>

            <section className="bg-slate-900 text-white">
                <div className="kanbr-container py-10 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                    <div>
                        <div className="eyebrow text-amber-500 mb-2">Factory Works</div>
                        <h2 className="font-display text-2xl md:text-3xl font-bold leading-tight">Visit us in NCR.</h2>
                        <p className="text-slate-300 mt-3 text-sm max-w-md">Book a factory walkthrough — see boards being cut, laminates being pressed, and finished modules ready for dispatch.</p>
                        <div className="mt-5 space-y-2 text-sm">
                            <div className="flex gap-2.5"><MapPin className="w-4 h-4 mt-0.5 text-amber-500" />{s.factory_address}</div>
                            <div className="flex gap-2.5"><Phone className="w-4 h-4 mt-0.5 text-amber-500" />+91 97737 04406</div>
                            <div className="flex gap-2.5"><Mail className="w-4 h-4 mt-0.5 text-amber-500" />{s.business_email}</div>
                        </div>
                    </div>
                    <img src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=900" alt="Wardrobe manufacturing" className="aspect-[4/3] object-cover w-full" />
                </div>
            </section>
        </div>
    );
}
